import styled from 'styled-components';

export const FixedFullscreenOverlay = styled.div({
  zIndex: 9990,
  position: 'fixed',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  overflow: 'hidden',
});
